<script setup>
// Reference 8 — the ask, in the same panel the homepage closes with: bg-primary, the
// large hard shadow, stamped into place. That stamp is the site's one playful beat and
// it is reserved for the close, so both public pages end the same way.
//
// The button says something other than the hero's "Start met een VvE" on purpose: two
// links with the same accessible name on one page is an ambiguity for a screen reader
// (and for the spec that asserts that link), and this one is the one that follows the
// setup steps — so it says what those steps start.
import { ref, onMounted, onUnmounted } from "vue";
import { ArrowRight, MessageCircle } from "@lucide/vue";
import { buttonVariants } from "@/components/ui/button";
import { useMotion, stampIn, vMagnetic } from "@/lib/motion";

const root = ref(null);
const ctaPanel = ref(null);

let cleanup = () => {};

onMounted(() => {
  cleanup = useMotion(root.value, () => {
    stampIn(ctaPanel.value);
  });
});

onUnmounted(() => cleanup());
</script>

<template>
  <section id="aan-de-slag" ref="root" class="border-t-2 border-foreground bg-card">
    <div class="mx-auto w-full max-w-6xl px-5 py-10 sm:py-16">
      <div ref="ctaPanel" class="border-2 border-foreground bg-primary p-6 text-primary-foreground shadow-[var(--shadow-hard-lg)] sm:p-14">
        <h2 class="max-w-3xl font-sans text-2xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Klaar om de eerste VvE over te zetten?
        </h2>
        <p class="mt-4 max-w-2xl text-sm leading-relaxed text-primary-foreground/85 sm:mt-5 sm:text-base">
          Begin met één VvE: verbind haar met Mollie op eigen naam, zet de eenheden en bedragen klaar en laat elke eigenaar één keer een machtiging
          afgeven. Daarna voeg je de volgende toe in hetzelfde account.
        </p>
        <div class="mt-6 flex flex-wrap items-center gap-4 sm:mt-9">
          <span v-magnetic class="inline-block">
            <RouterLink :to="{ path: '/signup', query: { voor: 'beheerder' } }" :class="buttonVariants({ variant: 'outline', size: 'lg' })">
              Begin met je eerste VvE<ArrowRight class="size-4" />
            </RouterLink>
          </span>
          <a
            href="https://wa.me/31643500374"
            class="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-foreground underline-offset-4 hover:underline"
          >
            <MessageCircle class="size-4" />Neem contact op
          </a>
        </div>
        <p class="mt-4 text-xs text-primary-foreground/85 sm:text-sm">
          WhatsApp heeft de voorkeur, maar je kunt ook
          <a href="tel:+31643500374" class="font-semibold underline-offset-4 hover:underline">bellen</a> of
          <a href="mailto:info@pandig.nl" class="font-semibold underline-offset-4 hover:underline">mailen</a>.
        </p>
      </div>
    </div>
  </section>
</template>
